var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mypage-manager"},[_c('h1',{staticClass:"mypage-title"},[_vm._v("마이페이지")]),_vm._v(" "),(_vm.mypageComponent === 'check')?_c('MyPageCheck'):_c('MyPa')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71db7b90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/MypageManager.vue
// module id = 306
// module chunks = 0